import { FC } from "react";
import { lighten, darken } from "@mui/material/styles";
import GlobalStyles from "@mui/material/GlobalStyles";
import { APP_COMPANY_COLOR, APP_COMPANY_FONT } from "consts";
import { useDynamicFavicon } from "./hooks";

type Props = {
  color?: string;
};

const Styles: FC<Props> = ({ color = APP_COMPANY_COLOR }) => {
  useDynamicFavicon(color);

  return (
    <GlobalStyles
      styles={{
        ":root": {
          "--color-primary": color,
          "--color-primary-light": lighten(color, 0.1),
          "--color-primary-dark": darken(color, 0.1),
          "--base-font-family": `"${APP_COMPANY_FONT}", sans-serif`,
        },
      }}
    />
  );
};

export default Styles;
